<template>
  <div class="home">
    <span class="high-score"></span><br><br><br>
    <img alt="CountMyString.com" src="../assets/logo.png">
    <StringOutput/>
    <StringInput/>
  </div>
</template>

<script>
import StringInput from '@/components/StringInput.vue'
import StringOutput from '@/components/StringOutput.vue'

export default {
  name: 'Home',
  components: {
    StringInput,
    StringOutput
  }
}
</script>
